module.exports = __webpack_public_path__ + "static/media/Jeff_Guo_Qing.e6b5b4fc.png";